import localStorageUtils from '../utils/localStorage.utils';

export default function getToken() {
	const loginToken = localStorageUtils.getLoginToken();
	const sessionToken = localStorageUtils.getSessionToken();

	return loginToken ?? sessionToken;
}
